// removed by extract-text-webpack-plugin
module.exports = {"_root":"styles___root___lyAql","base":"styles__base___1l9oR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Tooltip/styles.scss
// module id = 7050
// module chunks = 0